import Vue from "vue";
export default {
    namespaced: true,
    state: {
        items: [],
        value: null
    },

    getters: {
        items(state,) {
            return state.items;
        },
    },

    mutations: {
        SET_NULL(state) {
            state.value = null;
        },
        SELECT_GESTION(state, item) {
            state.value = item;
        },
        SET_GESTIONES(state, items = []) {
            state.items = [...state.items, ...items];
        },
        ADD_GESTION(state, oneItem) {
            state.items.push(oneItem);
        },
        DELETE_GESTION(state, data) {
            const ind = state.items.findIndex(gestion => gestion === data);
            if (ind !== -1) {
                state.items.splice(ind, 1);
            }
        },

        EDIT_GESTION(state, { data, gestion }) {
            const ind = state.items.findIndex(gestion => gestion === data);

            if (ind !== -1) {
                Vue.set(state.items, ind, gestion);
            }
        }
    },

    actions: {
        setGestionNull({ commit }) {
            return (commit('SET_NULL'), true)
        },

        selectGestion({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item === data);
            return exitsItem ? (commit('SELECT_GESTION', data), true) : false;
        },

        setGestiones({ state, commit }, data = []) {
            const savedItems = [...state.items]
            // window.console.log('setGestiones', data, state.items, savedItems);
            data.forEach(gestion => {
                if (!savedItems.find(item => item == gestion)) {
                    commit('ADD_GESTION', gestion);
                }
            });
            return true;
        },

        addGestion({ state, commit }, data) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item === data);
            return !exitsItem ? (commit('ADD_GESTION', data), true) : false;
        },

        deleteGestion({ state, commit }, gestion) {
            const savedItems = [...state.items]
            let exitsItem = savedItems.find(item => item === gestion);
            return exitsItem ? (commit('DELETE_GESTION', gestion), true) : false;
        },

        // editGestion({ commit }, data) {
        //     return new Promise(resolve => {
        //         setTimeout(() => {
        //             commit('EDIT_GESTION', data);
        //             resolve();
        //         }, 250);
        //     });
        // }
    }
};
